<div id="wrap" [@taskBookAnimation] *ngIf="taskBook">
  <div id="closeBtn">
    <span (click)="close()">×</span>
  </div>

  <div id="taskWrap"  class="fontSize16 lineHeight24" [innerHtml]="taskBook">
    <!--<div class="title fontSize24">
        协作任务书
    </div>
    <div class="fontSize16 lineHeight27">
      在与老板聊完之后，你积极的投入了个性化汽车方案的项目中去。在项目初始的一个月中，你有许多的设想，不过每个设想都需要各部门的协作，你准备一步一步来实现它。<br/><br/>
      请完善你的方案，选定你愿意与之建立协作伙伴关系的部门吧。<br/><br/>
      此练习用时约5分钟，题型有<span style="color: #7297e6">多选</span>和<span style="color: #7297e6">单选</span>两种。
    </div>-->
  </div>

  <div id="startBtn" class="fontSize18" (click)="goToNextStep()">
    开始任务
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-begin/case-practice-cooperation-begin.component.html